import BaseService from './BaseService';
import entities from 'src/config/entities'

class PlaceholdersService extends BaseService {

  constructor () {
    super({entity: entities.PLACEHOLDER})
  }
}

export default new PlaceholdersService()
